import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyPointsRing',
  initialState: false,
  reducers: {
    setLoyaltyPointsRing(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setLoyaltyPointsRing } = slice.actions;

export default slice.reducer;
